import isLaptopLarge from '../utils/is-laptop-large.js';
import EVENT from '../enums/event.js';

const classes = {
  hide: '-translate-y-[100%]',
  fixed: 'fixed',
  gradient_direction: 'bg-gradient-to-b',
  gradient_from: 'from-black/40',
  gradient_to: 'to-white/0',
  blend_mode: 'mix-blend-multiply',
  main: '.main',
  hero: '.hero-takeover',
  position_fixed: 'lgx:fixed',
  position_absolute: 'lgx:absolute',
  opacity0: 'opacity-0',
};

const selectors = {
  search: '[data-header-search]',
  searchInput: '[data-header-search-input]',
  mega_menu: '[data-mega-menu]',
  menu: '[data-header-menu]',
  mobile_menu: '[data-mobile-menu-burger]',
  bag: '[data-header-bag]',
  logo: '[data-header-logo]',
  background: '[data-header-background]',
  gradient: '[data-header-gradient]',
};

class StickyHeader {
  constructor(shopifyHeader) {
    this.shopifyHeader = shopifyHeader;
    this.currentScrollPos = window.pageYOffset;
    this.prevScrollpos = window.pageYOffset;
    this.headerSearch = document.querySelector(selectors.search) ?? false;
    this.headerSearchInput =
      document.querySelector(selectors.searchInput) ?? false;
    this.menu = document.querySelector(selectors.menu) ?? false;
    this.megaMenu = document.querySelector(selectors.mega_menu) ?? false;
    this.mobileMenu = document.querySelector(selectors.mobile_menu) ?? false;
    this.bag = document.querySelector(selectors.bag) ?? false;
    this.logo = document.querySelector(selectors.logo) ?? false;
    this.headerBackground =
      document.querySelector(selectors.background) ?? false;
    this.headerGradient = document.querySelector(selectors.gradient) ?? false;
    this.hasHero = document.querySelector(classes.hero) ?? false;
    this.mobile = window.matchMedia('(max-width:1224px)');

    this.search = window.addEventListener('scroll', this.scrollHandler);

    this.init();

    window.addEventListener('resize', () => {
      this.init();
    });

    window.addEventListener(EVENT.HEADER.WHITE, () => {
      this.setHeaderWhite();
    });
  }

  init() {
    if (this.hasHero) {
      if (isLaptopLarge()) {
        this.headerBackground.classList.remove(classes.opacity0);
        this.gradient('remove');
        this.switchToWhite('remove');
      } else {
        this.headerBackground.classList.add(classes.opacity0);
        this.switchToWhite('add');
        this.gradient('add');
      }
    } else {
      this.headerBackground.classList.remove(classes.opacity0);
    }

    this.hoverHandler();
  }

  shouldAddCss() {
    return (
      this.prevScrollpos > this.currentScrollPos && this.currentScrollPos !== 0
    );
  }

  atTop() {
    return this.currentScrollPos === 0;
  }

  addCss() {
    this.shopifyHeader.style.top = '0';
    this.shopifyHeader.classList.remove(classes.hide, classes.gradient);
    this.shopifyHeader.classList.add(classes.fixed);
    this.headerBackground.classList.remove(classes.opacity0);
    this.switchToWhite('remove');
    this.gradient('remove');
  }

  gradient(toggle) {
    this.headerGradient.classList[toggle](
      classes.gradient_direction,
      classes.gradient_from,
      classes.gradient_to,
      classes.blend_mode
    );
  }

  removeCss() {
    this.shopifyHeader.classList.remove(classes.hide, classes.fixed);
    this.headerBackground.classList.add(classes.opacity0);
    this.init();
  }

  switchToWhite(toggle) {
    if (this.menu) this.menu.classList[toggle]('text-white');
    if (this.mobileMenu) this.mobileMenu.classList[toggle]('fill-white');
    if (this.bag) this.bag.classList[toggle]('fill-white');
    if (this.logo) this.logo.classList[toggle]('fill-white');
    if (this.headerSearch)
      this.headerSearch.classList[toggle](
        'fill-white',
        'text-white',
        '!border-white'
      );
    if (this.headerSearchInput)
      this.headerSearchInput.classList[toggle]('placeholder:!text-white');
  }

  hoverHandler() {
    if (this.mobile.matches || !this.hasHero) return;

    [this.shopifyHeader, this.megaMenu].forEach(area => {
      area.addEventListener('mouseover', () => {
        this.setHeaderWhite();
      });
    });

    this.shopifyHeader.addEventListener('mouseleave', () => {
      if (this.atTop()) {
        this.unsetHeaderWhite();
      }
    });

    this.megaMenu.addEventListener('transitionend', () => {
      if (this.megaMenu.clientHeight === 0 && this.atTop()) {
        this.unsetHeaderWhite();
      }
    });
  }

  setHeaderWhite() {
    this.gradient('remove');
    this.switchToWhite('remove');
    this.headerBackground.classList.remove(classes.opacity0);
  }

  unsetHeaderWhite() {
    this.gradient('add');
    this.switchToWhite('add');
    this.headerBackground.classList.add(classes.opacity0);
  }

  shouldHideHeader() {
    return this.currentScrollPos > 200 && this.currentScrollPos !== 0;
  }

  hideHeader() {
    this.shopifyHeader.classList.add(classes.hide);
  }

  positionFixedNav() {
    this.megaMenu.classList.remove(classes.position_absolute);
    this.megaMenu.classList.add(classes.position_fixed);
  }

  positionAbsoluteNav() {
    this.megaMenu.classList.remove(classes.position_fixed);
    this.megaMenu.classList.add(classes.position_absolute);
  }

  scrollHandler = () => {
    this.currentScrollPos = window.pageYOffset;

    if (this.shouldAddCss()) {
      this.addCss();
    } else if (this.atTop()) {
      this.removeCss();
      this.positionAbsoluteNav();
    } else if (this.shouldHideHeader()) {
      this.hideHeader();
      this.positionFixedNav();
    }

    this.prevScrollpos = this.currentScrollPos;
  };
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new StickyHeader(document.querySelector('#shopify-section-header'));
});

export default StickyHeader;
